//
//
//
//
//
//
import * as echarts from "echarts";
export default {
  name: "TemperatureChart",
  props: {
    xdata: {
      type: Array,
      required: true
    },
    ydata: {
      type: Array,
      required: true
    }
  },
  mounted: function mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
  },
  watch: {
    xdata: "updateChart",
    ydata: "updateChart"
  },
  methods: {
    initChart: function initChart() {
      this.myChart = echarts.init(this.$refs.echart);
      this.updateChart();
    },
    updateChart: function updateChart() {
      var colors = ['#3398DB', '#00FF00', '#FF5733', '#FFC300']; // 颜色数组

      var seriesNames = ['Highest', 'Lowest', 'Average', 'Minimum']; // 数据集名称

      var option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          bottom: 0
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xdata
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false // 隐藏左侧刻度线

          },
          splitLine: {
            lineStyle: {
              type: 'dashed' // 设置为虚线

            }
          },
          axisTick: {
            show: false // 隐藏刻度线

          }
        },
        series: this.ydata.map(function (data, index) {
          return {
            name: seriesNames[index] || "Data ".concat(index + 1),
            // 获取名称
            type: "line",
            data: data,
            itemStyle: {
              color: colors[index % colors.length] // 循环使用颜色

            },
            markPoint: {
              data: [{
                type: "max",
                name: "Max"
              }, {
                type: "min",
                name: "Min"
              }]
            }
          };
        })
      };
      this.myChart.setOption(option);
    },
    resizeChart: function resizeChart() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
};